import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const opportunityApi = createApi({
   reducerPath: 'opportunityApi',
   baseQuery: baseQueryWithReauth,
   endpoints: (builder) => ({
      getopportunities: builder.query({
         query: ({ limit = '', name = '', page = 1 }) => {
            return {
               url: `/opportunity?limit=${limit}&name=${encodeURIComponent(name)}&page=${page}`,
               method: 'GET',
            };
         },
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),

      getPaginatedOpportunities: builder.query({
         query: ({ limit, page, orderBy, search }) => ({
            url: `/opportunity/pagination-search?limit=${limit}&page=${page}&orderBy=${orderBy}&search=${search}`,
            method: 'GET',
         }),
         async onQueryStarted(queryArg, { queryFulfilled }) {
            try {
               const { data } = await queryFulfilled;
               return data;
            } catch (err) {
               return err;
            }
         },
      }),
   }),
});

export const { useGetopportunitiesQuery, useGetPaginatedOpportunitiesQuery } = opportunityApi;
